<div class="header">
    Edit Route Workers for route: {{route.carrierName}}
</div>
<div class="body" *ngIf="(saving$ | async)" >
    <mat-progress-spinner strokeWidth="5" diameter="50" mode="indeterminate"></mat-progress-spinner>
</div>
<div class="footer" *ngIf="(saving$ | async)" >
    Processing...
</div>
<div class="body" *ngIf="!(saving$ | async)" >
    <form [formGroup]="editForm" (ngSubmit)="okayHandler()" class="form">
        <div class="form-content">
            <div class="wrapper">
                <div class="form-row">
                    <fieldset class="fieldset workers">
                        <div class="add-worker-section">
                            <form [formGroup]="workerForm" class="add_worker_form">
                                <div class="form-content">
                                    <div class="form-row">
                                        <mat-form-field class="full-width">
                                            <mat-label>Select Worker</mat-label>
                                            <input type="text" matInput formControlName="workerId" [matAutocomplete]="workerAuto">
                                            <mat-autocomplete #workerAuto="matAutocomplete" [displayWith]="displayWorkerFn">
                                                <mat-option *ngFor="let worker of (filteredWorkers$ | async)" [value]="worker.id">
                                                    {{worker.firstName}} {{worker.lastName}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>
                                    </div>
                                    <div class="form-row">
                                        <mat-form-field class="full-width">
                                            <mat-label>Select Role</mat-label>
                                            <mat-select formControlName="roleId">
                                                <mat-option *ngFor="let role of roles" [value]="role.id">
                                                    {{role.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="add_worker_button">
                                    <button mat-raised-button color="primary" (click)="addWorker()">
                                        <mat-icon>add</mat-icon>
                                        Add Worker
                                    </button>
                                </div>
                            </form>
                        </div>

                        <legend class="legend">Assigned Workers</legend>
                        <div class="workers-list">
                            <table mat-table [dataSource]="workersDataSource" class="mat-elevation-z8">
                                <!-- Worker Name Column -->
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef>Worker Name</th>
                                    <td mat-cell *matCellDef="let worker">{{worker.firstName}} {{worker.lastName}}</td>
                                </ng-container>

                                <!-- Role Column -->
                                <ng-container matColumnDef="role">
                                    <th mat-header-cell *matHeaderCellDef>Role</th>
                                    <td mat-cell *matCellDef="let worker">
                                        <mat-form-field>
                                            <mat-select [(value)]="worker.roleId" (selectionChange)="onRoleChange(worker, $event)">
                                                <mat-option *ngFor="let role of roles" [value]="role.id">
                                                    {{role.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </td>
                                </ng-container>

                                <!-- Actions Column -->
                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                                    <td mat-cell *matCellDef="let worker">
                                        <button mat-icon-button color="warn" (click)="removeWorker(worker)">
                                            <mat-icon>delete</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
        <div class="footer" *ngIf="!(saving$ | async)" >
            <button mat-raised-button type="button" (click)="cancelHandler()">Cancel</button>
            <button mat-raised-button type="submit" color="primary">Save</button>
        </div>
    </form>
</div> 